const data = {
  fastcompany: {
    logo:
      '//a.fastcompany.net/image/upload/v1488299125/fc/fastcompany-logo.svg',
    title: 'Fast Company',
    subscribeLink: 'https://www.fastcompany.com/combo',
    newsletterLink: 'https://www.fastcompany.com/newsletters',
    topics: [
      {
        url: '/co-design',
        title: 'Co.Design'
      },
      {
        url: '/technology',
        title: 'Tech'
      },
      {
        url: '/work-life',
        title: 'Work Life'
      },
      {
        url: '/creativity',
        title: 'Creativity'
      },
      {
        url: '/impact',
        title: 'Impact'
      },
      {
        url: '/section/audio',
        title: 'Podcasts'
      },
      {
        url: '/videos',
        title: 'Video'
      },
      {
        url: '/news',
        title: 'News'
      },
      {
        url: '/recommender',
        title: 'Recommender',
        removeOnScale: true
      },
      {
        url: 'https://magazine.fastcompany.com/loc/FST/sidenav1999',
        title: 'Subscribe',
        external: true,
        // removeOnScale: true,
        bold: true,
        subtopics: [
          {
            title: 'Newsletters',
            url: '/newsletters'
          },
          {
            title: 'Magazine',
            external: true,
            url: 'https://magazine.fastcompany.com/loc/FST/topnav1'
          },
          {
            title: 'Podcasts',
            external: true,
            url: 'https://podcasts.apple.com/us/artist/fast-company/1393767793'
          }
        ]
      }
    ],
    channels: [
      {
        logo: '',
        title: 'FastCo Works',
        items: [
          {
            url: '/fcw/citrix',
            title: 'Citrix'
          },
          {
            url: '/fcw/ford-transit',
            title: 'Ford Transit'
          }
        ]
      }
    ]
  }
};

export default data;
